"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'access.status.active': 'Attivo',
    'access.status.inactive': 'Inattivo',
};
